import useSWR from 'swr';
import { useNavigate } from 'react-router-dom';
import { fetchAllSubcategories } from './data-source.ts';
import type { SubcategoryListItemsProps } from '@ui/subcategory/subcategory-list';

export function useSubcategories({
  categoryId,
  categoryTitle,
}: {
  categoryId?: number;
  categoryTitle?: string;
}) {
  const { data, isLoading } = useSWR(
    categoryId ? `/api/categories?parent_id=${categoryId}` : null,
    fetchAllSubcategories
  );

  const navigate = useNavigate();

  const mapped = data && data[0].children && data[0].children?.map<SubcategoryListItemsProps | undefined>(
    (subcategoryItem) => {
      return {
        title: subcategoryItem.name,
        isLoading: false,
        onPress: () =>
          navigate(
            `/category/${categoryId}/${subcategoryItem.id}?ct=${categoryTitle || ''}&st=${subcategoryItem.name}`
          ),
      };
    }
  );

  const array = Array(5)
    .fill(undefined)
    .map(() => ({
      isLoading: true,
    }));

  return {
    data: mapped || array,
    rawData: data,
    isLoading,
  };
}
